var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-4"
        },
        [
          _c(
            "div",
            {
              staticClass: "body-1 mb-1 kvm-prov__title"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "pb-1",
                  attrs: {
                    size: "24",
                    color: "primary",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-rocket-launch")]
              ),
              _c(
                "span",
                {
                  staticClass: "ml-2"
                },
                [_vm._v("Set up your server")]
              )
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "mb-4 kvm-prov__lead"
            },
            [
              _vm._v(
                " Choose an operating system or a ready-made application. We'll build your server right away. "
              )
            ]
          ),
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "py-8 text-center",
                  attrs: {
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: "36",
                      width: "3",
                      "aria-hidden": "true"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "kvm-sr-only"
                    },
                    [_vm._v("Loading setup options…")]
                  )
                ],
                1
              )
            : _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: {
                    type: "error",
                    border: "left",
                    prominent: "",
                    role: "alert"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.error.message ||
                          "The setup options could not be loaded."
                      ) +
                      " "
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "mt-2"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "error--text",
                          attrs: {
                            small: "",
                            tile: "",
                            color: "white"
                          },
                          on: {
                            click: _vm.loadCatalog
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: ""
                              }
                            },
                            [_vm._v("mdi-refresh")]
                          ),
                          _vm._v("Retry ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : [
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 mb-1"
                  },
                  [_vm._v("Region")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "mb-4"
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "pb-1",
                        attrs: {
                          small: ""
                        }
                      },
                      [_vm._v("mdi-map-marker")]
                    ),
                    _vm._v(" " + _vm._s(_vm.region || "Set by your plan") + " ")
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 mb-2"
                  },
                  [_vm._v("Operating system / application")]
                ),
                _c("kvm-catalog-picker", {
                  staticClass: "mb-4",
                  attrs: {
                    "operating-systems": _vm.catalog.operating_systems,
                    apps: _vm.catalog.apps,
                    "confirm-label": "Use this"
                  },
                  model: {
                    value: _vm.selection,
                    callback: function callback($$v) {
                      _vm.selection = $$v
                    },
                    expression: "selection"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 mb-2 mt-4"
                  },
                  [
                    _vm._v(" Domain "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-prov__muted"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.domainRequired
                              ? "(required for app installs)"
                              : "(optional)"
                          )
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-start kvm-prov__domain",
                    staticStyle: {
                      "max-width": "560px"
                    }
                  },
                  [
                    _c("v-text-field", {
                      staticClass: "mr-2",
                      attrs: {
                        placeholder: "app.example.com",
                        outlined: "",
                        dense: "",
                        "persistent-hint": "",
                        hint: _vm.domainHint,
                        error: _vm.domainRequired && !_vm.domainInput.trim(),
                        "aria-required": _vm.domainRequired ? "true" : "false",
                        "aria-label": "Domain"
                      },
                      model: {
                        value: _vm.domainInput,
                        callback: function callback($$v) {
                          _vm.domainInput = $$v
                        },
                        expression: "domainInput"
                      }
                    }),
                    _vm.suggestedDomain
                      ? _c(
                          "gg-btn",
                          {
                            staticClass: "mt-1",
                            attrs: {
                              small: "",
                              tile: "",
                              outlined: "",
                              color: "primary",
                              "aria-label": "Generate a free subdomain"
                            },
                            on: {
                              click: _vm.generateDomain
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  left: "",
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-auto-fix")]
                            ),
                            _vm._v("Generate ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("kvm-domain-check", {
                  staticClass: "mt-1 mb-4",
                  attrs: {
                    "entitlement-id": _vm.entitlementId,
                    domain: _vm.domainInput
                  }
                }),
                _c("v-divider", {
                  staticClass: "mb-3"
                }),
                _c("kvm-ssh-keys", {
                  staticClass: "mb-4",
                  attrs: {
                    "entitlement-id": _vm.entitlementId,
                    selectable: ""
                  },
                  model: {
                    value: _vm.sshKeyIds,
                    callback: function callback($$v) {
                      _vm.sshKeyIds = $$v
                    },
                    expression: "sshKeyIds"
                  }
                }),
                _c(
                  "gg-btn",
                  {
                    staticClass: "kvm-prov__submit",
                    attrs: {
                      tile: "",
                      color: "primary",
                      loading: _vm.submitting,
                      disabled: !_vm.canSubmit,
                      "aria-busy": _vm.submitting ? "true" : "false"
                    },
                    on: {
                      click: _vm.submit
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-check")]
                    ),
                    _vm._v("Create server ")
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }